export default "__VITE_ASSET__abd291ab__"